import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MasterPage from "../master-page";
import localizationService from "../../services/localization-service";
import MoonLoader from "react-spinners/MoonLoader";
import DOMPurify from "dompurify";

export const TermsOfUse = () => {
  const selectedlang = useSelector((state) => state.account.lang);
  const rawTermsOfUseTextHtml = localizationService.getLocalizationValue(
    "termsOfUseText",
    selectedlang,
  );
  const safeTermsOfUseTextHtml = DOMPurify.sanitize(rawTermsOfUseTextHtml, {
    ADD_ATTR: ["target"],
  }); // remove ANY unsafe content
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 500) {
      setIsDesktopResolution(false);
    }
    setIsLoading(false);
  }, []);

  return (
    <MasterPage>
      <React.Fragment>
        {isLoading && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
            <MoonLoader
              color="#9aa82d"
              size={80}
              loading={isLoading}
              aria-label="Loading Spinner"
            />
          </div>
        )}

        <div
          className={`terms-of-use-page bg-white ${
            isDesktopResolution ? "rounded-2xl shadow-xl p-8 mb-8" : "px-1"
          }`}
        >
          <h1 className="terms-of-use-title my-[20px]">
            {localizationService.getLocalizationValue(
              "termsOfUseTitle",
              selectedlang,
            )}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: safeTermsOfUseTextHtml,
            }}
          ></div>
        </div>
      </React.Fragment>
    </MasterPage>
  );
};
